import { Component, OnDestroy, OnInit } from '@angular/core';
import { TypeValueFactoryService } from '../../../common/type-value-factory.service';
import { Reservation } from '../../reservation.model';
import { ReservationSummaryStoreService } from '../services/reservation-summary-store.service';
import { filter, Subscription } from 'rxjs';
import { ReservationSummaryApiService } from '../services/reservation-summary-api.service';
import { InfoboxService } from '../../../common/infobox/infobox.service';
import { LoaderService } from '../../../common/loader/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { ReservationSummaryInvoiceDialogComponent } from './reservation-summary-invoice-dialog/reservation-summary-invoice-dialog.component';

@Component({
	selector: 'app-reservation-summary-invoice',
	templateUrl: './reservation-summary-invoice.component.html',
	styleUrls: ['./reservation-summary-invoice.component.scss'],
})
export class ReservationSummaryInvoiceComponent implements OnInit, OnDestroy {
	reservation: Reservation = TypeValueFactoryService.createReservationObject();
	subscription: Subscription;

	constructor(
		private readonly store: ReservationSummaryStoreService,
		private readonly apiService: ReservationSummaryApiService,
		private readonly infobox: InfoboxService,
		private readonly loader: LoaderService,
		private readonly dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.subscription = this.store
			.getters()
			.reservation()
			.pipe(filter((reservation) => !!reservation))
			.subscribe((reservation) => {
				this.reservation = reservation;
			});
	}

	ngOnDestroy() {
		this.subscription?.unsubscribe();
	}

	get ownerNip(): string {
		return this.reservation?.ownerNip ? this.reservation.ownerNip : 'Brak';
	}

	enableInvoice() {
		this.updateInvoiceStatus(true);
	}

	disableInvoice() {
		this.updateInvoiceStatus(false);
	}

	updateInvoiceStatus(status: boolean) {
		this.loader.show('invoice-change');
		this.apiService
			.actions()
			.patchReservation({ id: this.reservation.id, invoice: status })
			.then(() => {
				this.infobox.success('Pomyślnie zmieniono chęć wystawienia faktury');
			})
			.finally(() => {
				this.apiService.actions().getReservation(this.reservation.id);
				this.loader.hide('invoice-change');
			});
	}

	openInvoiceDialog() {
		this.dialog.open(ReservationSummaryInvoiceDialogComponent, {
			height: '215px',
		});
	}
}
